export const isPromoActive = (startDate, endDate) => {
  const currentDate = new Date().getTime();
  return currentDate > startDate && currentDate <= endDate;
};